<template lang="pug">
  div
    b-tabs(justified, small, lazy)
      b-tab(title="Propiedades")
        Properties.mt-2
      b-tab(title="Filtros de entrenamiento")
        QuestionBlockFilters.mt-2
</template>

<script>
import QuestionBlockFilters from './QuestionBlockFilters'
import Properties from './Properties'
export default {
  name: 'FiltersAndPropertiesRouter',
  components: { Properties, QuestionBlockFilters }
}
</script>

<style scoped>

</style>